namespace Portico.Services {

    import Inject = Portico.Decorators.Inject;
    import Service = Portico.Decorators.Service;

	import pmi = Portico.Models.Interfaces;
	import ps = Portico.Services;

    export interface IApiService {
		getItem: <T>(endPoint: string, spinner?: string) => ng.IPromise<T>;
		searchItem: <T, U>(endPoint: string, item: T, spinner?: string) => ng.IPromise<U>;
        saveItem: <T, U>(endPoint: string, item: T, spinner?: string) => ng.IPromise<U>;
		deleteItem: (endPoint: string, spinner?: string) => ng.IPromise<boolean>;
    }

    @Service('app', 'apiService')
	@Inject('$http', '$q', 'serverConstants', 'modalService', '$rootScope')
    export class ApiService implements IApiService {
        constructor(
            private $http: ng.IHttpService,
            private $q: ng.IQService,
			private serverConstants: pmi.IServerConstants,
            private modalService: ps.IModalService,
            private $rootScope: ng.IRootScopeService
        ) { }

        getItem<T>(endPoint: string, spinner: string = 'spinner'): ng.IPromise<T> {
            this.showSpinner(spinner);

            const deferred = this.$q.defer<T>();

            const req: angular.IRequestConfig = {
                method: 'GET',
                url: `${this.serverConstants.apiPath}${endPoint}`,
                headers: this.getStandardHeaders()
            }

			this.$http<T>(req).then((response) => {
				deferred.resolve(response.data);
			}, () => {
				deferred.reject();
            }).finally(() => {
                this.hideSpinner(spinner);
			});

            return deferred.promise;
        }

		searchItem<T, U>(endPoint: string, item: T, spinner: string = 'spinner'): ng.IPromise<U> {
            this.showSpinner(spinner);

            const deferred = this.$q.defer<U>();

            const req: angular.IRequestConfig = {
                method: 'POST',
                url: `${this.serverConstants.apiPath}${endPoint}`,
                headers: this.getStandardHeaders(),
                data: JSON.stringify(item)
            };

            this.$http<U>(req).then((response) => {
                deferred.resolve(response.data);
            }, () => {
                deferred.reject();
			}).finally(() => {
                this.hideSpinner(spinner);
			});

            return deferred.promise;
        }

		saveItem<T, U>(endPoint: string, item: T, spinner: string = 'spinner'): ng.IPromise<U> {
			this.showSpinner(spinner);

			const deferred = this.$q.defer<U>();

            const req: angular.IRequestConfig = {
                method: 'PUT',
                url: `${this.serverConstants.apiPath}${endPoint}`,
                headers: this.getStandardHeaders(),
                data: JSON.stringify(item)
            };

            this.$http<U>(req).then((response) => {
                deferred.resolve(response.data);
            }, (message) => {
                deferred.reject();
			}).finally(() => {
				this.hideSpinner(spinner);
			});

            return deferred.promise;
        }

		deleteItem(endPoint: string, spinner: string = 'spinner'): ng.IPromise<boolean> {
			this.showSpinner(spinner);

            const deferred = this.$q.defer<boolean>();

            const req: angular.IRequestConfig = {
                method: 'DELETE',
                url: `${this.serverConstants.apiPath}${endPoint}`,
                headers: this.getStandardHeaders()
            }

            this.$http<boolean>(req).then((response) => {
                deferred.resolve(response.data);
            }, () => {
                deferred.reject();
			}).finally(() => {
				this.hideSpinner(spinner);
			});

            return deferred.promise;
        }

        private showSpinner(spinner: string): void {
            if (_.get(this.$rootScope, 'spinnerDisabled', false) === false) {
                // this.modalService.show(spinner);
                document.getElementById('global-spinner-overlay').style.display = 'flex';
            }
        }

        private hideSpinner(spinner: string): void {
            // this.modalService.hide(spinner);
            document.getElementById('global-spinner-overlay').style.display = 'none';
        }

        private getStandardHeaders() {
            return { 'x-requested-with': 'XMLHttpRequest' };
        }
    }
}